import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function PricingCTA() {
  return <SectionWrapper alternate id="pricing" data-id="element-209">
      <motion.div className="text-center" variants={childVariants} data-id="element-210">
        <motion.p className="font-body text-cream-muted mb-6 text-[24px]" variants={childVariants} data-id="element-211">
          Get The 3AM Reset Today
        </motion.p>

        <motion.div className="flex items-center justify-center gap-3 mb-2" variants={childVariants} data-id="element-212">
          <span className="font-heading md:text-3xl text-cream-muted line-through decoration-cream-faint/50 text-[18px]" data-id="element-213">
            USD 19.99
          </span>
          <span className="font-heading md:text-6xl font-bold text-cream text-[32px]" data-id="element-214">
            USD 6.39
          </span>
          <span className="bg-amber/90 text-deep font-body font-bold px-3 py-1 rounded-full tracking-wide text-[14px]" data-id="element-215">
            68% OFF
          </span>
        </motion.div>

        <motion.div className="mb-4" variants={childVariants} data-id="element-216">
          <CTAButton className="text-xl px-10 py-5" data-id="element-217">
            Download The 3AM Reset Now
          </CTAButton>
        </motion.div>

        <motion.p className="font-body text-base text-cream-muted mb-12" variants={childVariants} data-id="element-218">
          Instant PDF download · Save offline · Print the Nightstand Card
        </motion.p>

        <motion.div className="h-px w-16 bg-teal/20 mx-auto mb-10" variants={childVariants} data-id="element-219" />

        <motion.p className="font-body text-lg text-cream leading-loose-plus mb-4" variants={childVariants} data-id="element-220">
          And the next time you wake up at 3:12am with your brain trying to drag
          you into a spiral…
        </motion.p>

        <motion.p className="font-body text-lg text-cream leading-loose-plus mb-8" variants={childVariants} data-id="element-221">
          You won't have to think.
        </motion.p>

        <motion.p className="font-heading text-xl md:text-2xl text-teal-light font-semibold" variants={childVariants} data-id="element-222">
          You'll just run the protocol.
        </motion.p>
      </motion.div>
    </SectionWrapper>;
}